import CommonFilterStore from '../CommonFilter/Store';

class DurationFilterStore extends CommonFilterStore {
  getFilterValues(): string[] {
    return this._filters.durations.map((d) => d.payload.value.toString());
  }
}

export default DurationFilterStore;
